import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toList1w8cr0enigbnc as toList } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collection.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { DefaultApolloException8w3ielfxng0h as DefaultApolloException } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import {
  first58ocm7j58k3q as first,
  drop3na99dw9feawf as drop,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Builder32honxq3tatym as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_singleSuccessOrException__rcjnkn($this, flow, $completion) {
  var tmp = toList(flow, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var responses = tmp;
  // Inline function 'kotlin.collections.partition' call
  var first_0 = ArrayList().u2();
  var second = ArrayList().u2();
  var _iterator__ex2g4s = responses.u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    if (!(element.c44_1 == null)) {
      first_0.n2(element);
    } else {
      second.n2(element);
    }
  }
  var _destruct__k2r9zo = new (Pair())(first_0, second);
  var exceptionResponses = _destruct__k2r9zo.df();
  var successResponses = _destruct__k2r9zo.ef();
  var tmp_0;
  switch (successResponses.v2()) {
    case 0:
      var tmp_1;
      switch (exceptionResponses.v2()) {
        case 0:
          throw DefaultApolloException().m44('The operation did not emit any item, check your interceptor chain');
        case 1:
          tmp_1 = first(exceptionResponses);
          break;
        default:
          var first_1 = first(exceptionResponses);
          var tmp_2 = first_1.f43();
          var tmp0 = drop(exceptionResponses, 1);
          // Inline function 'kotlin.collections.fold' call

          var accumulator = ensureNotNull(first_1.c44_1);
          var _iterator__ex2g4s_0 = tmp0.u1();
          while (_iterator__ex2g4s_0.v1()) {
            var element_0 = _iterator__ex2g4s_0.w1();
            // Inline function 'kotlin.also' call
            var this_0 = accumulator;
            addSuppressed(this_0, ensureNotNull(element_0.c44_1));
            accumulator = this_0;
          }

          var tmp$ret$5 = accumulator;
          tmp_1 = tmp_2.v43(tmp$ret$5).c37();
          break;
      }

      tmp_0 = tmp_1;
      break;
    case 1:
      tmp_0 = first(successResponses);
      break;
    default:
      throw DefaultApolloException().m44('The operation returned multiple items, use .toFlow() instead of .execute()');
  }
  return tmp_0;
}
function singleSuccessOrException($this, flow, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_singleSuccessOrException__rcjnkn.bind(VOID, $this, flow), $completion);
}
var ApolloCallClass;
function ApolloCall() {
  if (ApolloCallClass === VOID) {
    class $ {
      static d60(apolloClient, requestBuilder) {
        var $this = createThis(this);
        $this.b60_1 = apolloClient;
        $this.c60_1 = requestBuilder;
        return $this;
      }
      static e60(apolloClient, operation) {
        return this.d60(apolloClient, new (Builder())(operation));
      }
      k42(name, value) {
        // Inline function 'kotlin.apply' call
        this.c60_1.k42(name, value);
        return this;
      }
      f60() {
        return this.b60_1.b61(this.c60_1.c37(), false);
      }
      n5y($completion) {
        return singleSuccessOrException(this, this.f60(), $completion);
      }
    }
    initMetadataForClass($, 'ApolloCall', VOID, VOID, VOID, [0, 1]);
    ApolloCallClass = $;
  }
  return ApolloCallClass;
}
//region block: exports
export {
  ApolloCall as ApolloCallpwdxdy18rzuy,
};
//endregion

//# sourceMappingURL=ApolloCall.mjs.map
